module.exports = __webpack_public_path__ + "img/new_color_pngs.3554e60d.png";